import useSWR, { SWRConfiguration } from "swr";
import { ObjectToQueryString } from "../helpers";
import useIsTeam from "./useIsTeam";
import { get } from "@/backend";

const useProjects = (
  {
    q,
    query,
    sort,
  }: { q?: string; useStore?: boolean; sort?: string; query?: any },
  options?: SWRConfiguration,
) => {
  const { id, isTeam } = useIsTeam();

  const queryObject: any = {};
  if (query) {
    Object.keys(query).forEach((key) => {
      queryObject[key] = query[key];
    });
  }
  if (q) queryObject.q = q;

  if (sort) queryObject.sort = sort;

  if (isTeam) queryObject.teamId = id;

  if (query?.serviceType) queryObject.serviceType = query.serviceType;

  const url = `/v1/projects?${ObjectToQueryString(queryObject)}`;

  const { data, error, mutate, isLoading } = useSWR(url, get, {
    ...options,
    keepPreviousData: !!q,
  });

  return {
    projects: data?.data || {},
    loading: isLoading,
    error,
    mutate,
  };
};
export default useProjects;
